import firebaseApp from '../../../../services/firebaseService';
import { BasicBaseHelper, IBasicBaseClass } from '../../base';

export interface IPumpingStationVoluteCasingMake extends IBasicBaseClass {
    name : string;
    types : Array<string>;

    isActive : boolean;
}

export default class PumpingStationVoluteCasingMakeHelper extends BasicBaseHelper {
    public static readonly COLLECTION_NAME = 'pumping_station_volute_casing_make';

    private static converter : firebase.firestore.FirestoreDataConverter<IPumpingStationVoluteCasingMake> = {
        fromFirestore: (snapshot) => {
            return PumpingStationVoluteCasingMakeHelper.fromFirestoreDocument(snapshot);
        },
        toFirestore: (data : IPumpingStationVoluteCasingMake) : firebase.firestore.DocumentData => {
            return PumpingStationVoluteCasingMakeHelper.toFirestoreDocument(data);
        },
    };

    public static fromFirestoreDocument(snapshot : firebase.firestore.DocumentSnapshot) : IPumpingStationVoluteCasingMake {
        const result = super.fromFirestore(snapshot);
        const data = snapshot.data();

        if (!snapshot.exists || !result || !data) throw new Error(`Document does not exist! ${snapshot.id}`);
        return {
            ...data as IPumpingStationVoluteCasingMake,
            ...result,
        };
    }

    public static toFirestoreDocument(data : IPumpingStationVoluteCasingMake) {
        const result = super.toFirestore(data);
        const { id: _id, ...rest } = data;

        return {
            ...rest,
            ...result,
        };
    }

    public static doc(id ?: string) {
        if (!id) {
            return firebaseApp.firestore().collection(PumpingStationVoluteCasingMakeHelper.COLLECTION_NAME).withConverter(PumpingStationVoluteCasingMakeHelper.converter).doc();
        }

        return firebaseApp.firestore().collection(PumpingStationVoluteCasingMakeHelper.COLLECTION_NAME).withConverter(PumpingStationVoluteCasingMakeHelper.converter).doc(id);
    }

    public static save(company : IPumpingStationVoluteCasingMake) {
        return PumpingStationVoluteCasingMakeHelper.doc(company.id).set(company, {
            merge: true,
        });
    }
    
    public static collection() {
        return firebaseApp
            .firestore()
            .collection(PumpingStationVoluteCasingMakeHelper.COLLECTION_NAME)
            .withConverter(PumpingStationVoluteCasingMakeHelper.converter);
    }
}